import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { forwardRef, useId } from 'react';
import { Icon } from '../Icon';
import TextInputWrapper from '../TextInputWrapper';
import styles from './Select.module.css';
import { SelectProps } from './types';
const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(t0, ref) {
  const $ = _c(43);
  let ariaDisabled_;
  let children;
  let description;
  let disabled;
  let disabled_;
  let error;
  let fullWidth;
  let hint;
  let id_;
  let label;
  let name;
  let props;
  let required;
  let t1;
  let warning;
  if ($[0] !== t0) {
    ({
      "id": id_,
      name,
      children,
      label,
      hint,
      required,
      disabled,
      disabled_,
      "aria-disabled": ariaDisabled_,
      description,
      error,
      warning,
      errorDisplay: t1,
      fullWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaDisabled_;
    $[2] = children;
    $[3] = description;
    $[4] = disabled;
    $[5] = disabled_;
    $[6] = error;
    $[7] = fullWidth;
    $[8] = hint;
    $[9] = id_;
    $[10] = label;
    $[11] = name;
    $[12] = props;
    $[13] = required;
    $[14] = t1;
    $[15] = warning;
  } else {
    ariaDisabled_ = $[1];
    children = $[2];
    description = $[3];
    disabled = $[4];
    disabled_ = $[5];
    error = $[6];
    fullWidth = $[7];
    hint = $[8];
    id_ = $[9];
    label = $[10];
    name = $[11];
    props = $[12];
    required = $[13];
    t1 = $[14];
    warning = $[15];
  }
  const errorDisplay = t1 === undefined ? "all" : t1;
  const generatedId = useId();
  const id = id_ || name || generatedId;
  const inputDisabled = disabled_ || disabled;
  const ariaDisabled = ariaDisabled_ || inputDisabled;
  const t2 = id || name;
  const t3 = fullWidth && fullWidth !== "mobile-only";
  const t4 = fullWidth && fullWidth === "mobile-only";
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = classNames(styles.select, {
      "fullWidth": t3,
      "fullWidthOnMobile": t4
    });
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== ariaDisabled || $[20] !== children || $[21] !== disabled_ || $[22] !== id || $[23] !== name || $[24] !== props || $[25] !== ref || $[26] !== t5) {
    t6 = <select {...props} ref={ref} className={t5} id={id} name={name} aria-disabled={ariaDisabled} disabled={disabled_}>{children}</select>;
    $[19] = ariaDisabled;
    $[20] = children;
    $[21] = disabled_;
    $[22] = id;
    $[23] = name;
    $[24] = props;
    $[25] = ref;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon name="chevronDown" />;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t6) {
    t8 = <div className={styles.selectContainer}>{t6}{t7}</div>;
    $[29] = t6;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== description || $[32] !== error || $[33] !== errorDisplay || $[34] !== fullWidth || $[35] !== hint || $[36] !== label || $[37] !== name || $[38] !== required || $[39] !== t2 || $[40] !== t8 || $[41] !== warning) {
    t9 = <TextInputWrapper label={label} name={name} description={description} error={error} warning={warning} id={t2} required={required} errorDisplay={errorDisplay} fullWidth={fullWidth} hint={hint}>{t8}</TextInputWrapper>;
    $[31] = description;
    $[32] = error;
    $[33] = errorDisplay;
    $[34] = fullWidth;
    $[35] = hint;
    $[36] = label;
    $[37] = name;
    $[38] = required;
    $[39] = t2;
    $[40] = t8;
    $[41] = warning;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  return t9;
});
export default Select;